var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPath4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80.392,
    height: 70.343,
    viewBox: "0 0 80.392 70.343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M5.02448 0C2.24531 0 0 2.24531 0 5.02447C0 5.02447 0 42.708 0 42.708L0 50.2447C0 50.2447 0 62.8059 0 62.8059C0 66.9668 3.37582 70.3426 7.53672 70.3426C7.53672 70.3426 72.8549 70.3426 72.8549 70.3426C77.0158 70.3426 80.3916 66.9668 80.3916 62.8059C80.3916 62.8059 80.3916 42.708 80.3916 42.708C80.3916 42.708 80.3916 18.8732 80.3916 18.8732C80.3916 16.0155 77.3456 14.2098 74.8333 15.5602C74.8333 15.5602 50.2448 28.7965 50.2448 28.7965C50.2448 28.7965 50.2448 18.8732 50.2448 18.8732C50.2448 16.0155 47.1987 14.2098 44.6865 15.5602C44.6865 15.5602 20.0979 28.7965 20.0979 28.7965C20.0979 28.7965 20.0979 5.02447 20.0979 5.02447C20.0979 2.24531 17.8526 0 15.0734 0C15.0734 0 5.02448 0 5.02448 0C5.02448 0 5.02448 0 5.02448 0Z",
    fill: "#6C8665",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath4);
export default __webpack_public_path__ + "static/media/Path 4.8c39b17a6c28837d40fa28c3193f0a32.svg";
export { ForwardRef as ReactComponent };